// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"149fa8b9","611":"aeef81ab","787":"f216ee4f"}[chunkId] + ".chunk.js";
};